import request from '@/utils/request'

// 配置列表
export function setNumberindexList(params) {
  return request({
    url: '/appletPhotos/setNumber/index',
    method: 'get',
    params
  })
}

// 配置删除
export function setNumberindexdelete(id) {
  return request({
    url: `/appletPhotos/setNumber/delete?app_id=${id}`,
    method: 'post'
  })
}
// 配置次数新增
export function setNumberindexAdd(data = {}) {
  return request({
    url: '/appletPhotos/setNumber/store',
    method: 'post',
    data
  })
}
// 配置次数编辑
export function setNumberindexUpdate(data = {}) {
  return request({
    url: '/appletPhotos/setNumber/update',
    method: 'post',
    data
  })
}
// 图片上传保存
export function storeBatch(data = {}) {
  return request({
    url: '/appletPhotos/gallery/storeBatch',
    method: 'post',
    data
  })
}
// 图库列表
export function getMaterialLibraryList(params = {}) {
  return request({
    url: '/appletPhotos/gallery/list',
    method: 'get',
    params
  })
}
// 图片删除
export function storeBatchdelete(data = {}) {
  return request({
    url: '/appletPhotos/gallery/delete',
    method: 'post',
    data
  })
}
// 小说列表
export function promotionlinklist(params = {}) {
  return request({
    url: '/ad1/iqiyi/promotion_link/novel_list',
    method: 'get',
    params
  })
}
// 章节列表
export function chapterList(params = {}) {
  return request({
    url: '/ad1/iqiyi/promotion_link/chapter_list',
    method: 'get',
    params
  })
}

// 小说备注修改
export function novelRemark(data = {}) {
  return request({
    url: '/ad1/iqiyi/promotion_link/novel_remark',
    method: 'post',
    data
  })
}
